var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyDateIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 3V1H9V3H7ZM2 21V19.125H4L4 21H6V23H4C2.89543 23 2 22.1046 2 21ZM4 4H6V6H4V7.875H2V6C2 4.89543 2.89543 4 4 4ZM4 15.375H2V11.625H4V15.375ZM14 6H10H7V4H10H14H17V6H14ZM18 6V4H20C21.1046 4 22 4.89543 22 6V7.875H20V6H18ZM20 11.625H22V15.375H20V11.625ZM20 19.125H22V21C22 22.1046 21.1046 23 20 23H18V21H20V19.125ZM14 21V23H10V21H14ZM8.31579 15H6.21053V17H8.31579V15ZM11.4738 15H13.579V17H11.4738V15ZM18.8422 15H16.7369V17H18.8422V15ZM15 1V3H17V1H15ZM22 11H2V9H22V11Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyDateIcon);
export default __webpack_public_path__ + "static/media/empty-date-icon.18c8d6158aaba1dc63777721dd0da365.svg";
export { ForwardRef as ReactComponent };